import { initializeApp, getApps, FirebaseApp } from 'firebase/app';

let app: FirebaseApp | null = null;

export function initFirebase() {
  const apiKey            = process.env.REACT_APP_FIREBASE_API_KEY;
  const authDomain        = process.env.REACT_APP_FIREBASE_AUTH_DOMAIN;
  const projectId         = process.env.REACT_APP_FIREBASE_PROJECT_ID;
  const storageBucket     = process.env.REACT_APP_FIREBASE_STORAGE_BUCKET;
  const messagingSenderId = process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID;
  const appId             = process.env.REACT_APP_FIREBASE_APP_ID;

  if (!apiKey || !projectId) {
    return { app: null };
  }

  if (getApps().length === 0) {
    app = initializeApp({ apiKey, authDomain, projectId, storageBucket, messagingSenderId, appId });
  }

  return { app };
}

export function getFirebaseApp() {
  return app;
}
